/* @flow */
import cx from 'classnames';
import Image from 'components/Image';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';
import * as React from 'react';

import './styles/ChatWelcomeMessage.scss';

type Props = {
  className?: ?string,
  firstHeader: React.Node,
  secondHeader: React.Node,
};

class ChatWelcomeMessage extends React.Component<Props, void> {
  render() {
    const { firstHeader, secondHeader } = this.props;

    return (
      <div className={cx('ChatWelcomeMessage', this.props.className)}>
        <Image
          className="ChatWelcomeMessage-hero"
          src={require('assets/images/chat-welcome-hero.png')}
        />
        <Heading level="1" levelStyle="2">
          Welcome!
        </Heading>
        {firstHeader && (
          <Row size="small">
            <Text italic size="medium">
              {firstHeader}
            </Text>
          </Row>
        )}
        {secondHeader && (
          <Row>
            <Text color="thunder" size="medium">
              {secondHeader}
            </Text>
          </Row>
        )}
      </div>
    );
  }
}

export default ChatWelcomeMessage;
